var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "membership-page page"
  }, [_c('m-head', {
    ref: "mHeadRef"
  }), _c('div', {
    staticClass: "membership-main page-main"
  }, [_c('div', {
    staticClass: "membership-tab"
  }, [_c('m-tab', {
    attrs: {
      "tab": _vm.tabList,
      "selectTab": _vm.selectTab
    },
    on: {
      "update:selectTab": function ($event) {
        _vm.selectTab = $event;
      },
      "update:select-tab": function ($event) {
        _vm.selectTab = $event;
      }
    }
  })], 1), _vm.selectTab && _vm.selectTab.value == 0 ? [_c('membership-fan')] : _vm.selectTab && _vm.selectTab.value == 1 ? [_c('membership-vip')] : _vm.selectTab && _vm.selectTab.value == 2 ? [_c('membership-prop')] : _vm._e()], 2), _c('m-menu')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };